import { render, staticRenderFns } from "./DatasetTilesHeader.vue?vue&type=template&id=4bd2d792&scoped=true&functional=true"
var script = {}
import style0 from "./DatasetTilesHeader.vue?vue&type=style&index=0&id=4bd2d792&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "4bd2d792",
  null
  
)

export default component.exports